import {SuppliersTabApp} from "../../Funtionality/SupplierTab/SuppliersTabApp";
import DeleteModal from "../../../../Modals/DeleteModal";
import {VIEW_TYPE} from "../../../../../enums/ViewType";
import React from "react";
import SuppliersTable from "./SuppliersTable";
import SupplierCards from "./SupplierCards";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

const SuppliersTab = ({
    view,
    setView,
    supplierId,
    searchElement,
    setSearch,
    contractorId,
    setModified,
    modified,
    setSimpleSearch,
    finalArray,
    search,
    setSearchElement,
    bodyForExport,
    setBodyForExport,
    setCriteria,
    selectedList,
    setSelectedList,
    setDeleteSupplierShow,
    deleteSupplierShow,
    isAllChecked,
    setIsAllChecked,
    handleCreate
}) => {

    const {
        t,
        deleteSelectedSuppliers
    } = SuppliersTabApp({
        setModified,
        setIsAllChecked,
        setSelectedList
    })

    return (
        <>
            {view === VIEW_TYPE.GRID.name && (
                <>
                    <SupplierCards
                        contractorId={contractorId}
                        supplierId={supplierId}
                        view={view}
                        setView={setView}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        search={search}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        finalArray={finalArray}
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        isAllChecked={isAllChecked}
                        setIsAllChecked={setIsAllChecked}
                        setCriteria={setCriteria}
                        modified={modified}
                        setModified={setModified}
                        bodyForExport={bodyForExport}
                        setBodyForExport={setBodyForExport}
                        handleCreate={handleCreate}
                    />
                </>
            )}

            {view === VIEW_TYPE.LIST.name && (
                <SuppliersTable
                    contractorId={contractorId}
                    supplierId={supplierId}
                    view={view}
                    setView={setView}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    search={search}
                    setSearch={setSearch}
                    setSimpleSearch={setSimpleSearch}
                    finalArray={finalArray}
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    isAllChecked={isAllChecked}
                    setIsAllChecked={setIsAllChecked}
                    setCriteria={setCriteria}
                    modified={modified}
                    setModified={setModified}
                    bodyForExport={bodyForExport}
                    setBodyForExport={setBodyForExport}
                    handleCreate={handleCreate}
                />
            )}

            <DeleteModal
                show={deleteSupplierShow}
                onHide={() => setDeleteSupplierShow(false)}
                onClickFn={() => deleteSelectedSuppliers(selectedList)}
                data={selectedList}
                title_modal={t('delete_suppliers')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('suppliers')}
            />
        </>
    )
}

export default SuppliersTab
